/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Join_FailedInputs */

const en_invite_x15_join_failed = /** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not add you to the workspace. Try again, or ask the person who invited you for a new invitation.`)
};

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const ar_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const he_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const ur_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const es_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const fr_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const de_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const pt_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const hi_invite_x15_join_failed = en_invite_x15_join_failed;

/** @type {(inputs: Invite_X15_Join_FailedInputs) => LocalizedString} */
const bn_invite_x15_join_failed = en_invite_x15_join_failed;

/**
* | output |
* | --- |
* | "We could not add you to the workspace. Try again, or ask the person who invited you for a new invitation." |
*
* @param {Invite_X15_Join_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_join_failed = /** @type {((inputs?: Invite_X15_Join_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Join_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_join_failed(inputs)
	if (locale === "he") return he_invite_x15_join_failed(inputs)
	if (locale === "ur") return ur_invite_x15_join_failed(inputs)
	if (locale === "es") return es_invite_x15_join_failed(inputs)
	if (locale === "fr") return fr_invite_x15_join_failed(inputs)
	if (locale === "de") return de_invite_x15_join_failed(inputs)
	if (locale === "pt") return pt_invite_x15_join_failed(inputs)
	if (locale === "hi") return hi_invite_x15_join_failed(inputs)
	if (locale === "bn") return bn_invite_x15_join_failed(inputs)
	return /** @type {LocalizedString} */ ("We could not add you to the workspace. Try again, or ask the person who invited you for a new invitation.")
});